module.exports = __webpack_public_path__ + "static/media/img04.ef6d2c01.svg";